module.exports = __webpack_public_path__ + "assets/img/2-1.d92c3e26.png";